import { createBooleanChromeRegistrar } from "@/react/components/Mobile/shell/chrome/createBooleanChromeRegistrar";

/**
 * Renderless component that opts `MobileShell.Content` into `fullBleed`
 * for the lifetime of the mounting component, and restores the default
 * padded layout on unmount.
 *
 * See `createBooleanChromeRegistrar` for the shared implementation.
 */
export const MobileFullBleedContentRegistrar = createBooleanChromeRegistrar(
  context => context.setIsFullBleedContent,
  "MobileFullBleedContentRegistrar",
);
